import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center p-3 shadow-lg fw-bold">
      <p className="mb-0">
        &copy; {new Date().getFullYear()} Document Reminder System. All Rights
        Reserved.
      </p>
    </footer>
  );
};

export default Footer;
